import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import { ExportFileDropdownComponent }         from '../../components/Exports/ExportFileDropdown.component';
import { ExportFieldDropdownComponent }         from '../../components/Exports/ExportFieldDropdown.component';

//baseclasses
import { BaseEditComponent }         from '../../baseclasses/BaseEdit.component';

@Component({
  selector: 'my-filefield-edit',
  templateUrl: './FileFieldEdit.component.html',
  providers: [{provide: BaseEditComponent, useExisting: forwardRef(() => FileFieldEditComponent)}]
})
export class FileFieldEditComponent extends BaseEditComponent {

    public displayDialog: boolean;

    form: FormGroup;

    @ViewChild(ExportFileDropdownComponent) public exportFileDropdownComponent: ExportFileDropdownComponent;
    @ViewChild(ExportFieldDropdownComponent) public exportFieldDropdownComponent: ExportFieldDropdownComponent;

    @Input() public record: ent.FileField;

    @Output() onOK = new EventEmitter();

    constructor(fb: FormBuilder) 
    { 
        super();
        let group = {
            'File' : '',
            'Field' : '',
            'Sequence' : '',
            'Inactive' : ''
        };
        
        this.form = fb.group(group);
    }


    ngOnInit(): void {
        
    }

    onHide(){
        this.displayDialog = false;
    }

    onOKClick(event: any){
        
        this.onOK.emit();
        this.displayDialog = false;

    }

    fileChange(event: any){
        
        this.record.FileID = event;
    }

    fieldChange(event: any){
        
        this.record.FieldID = event;
    }

   
}